import { render, staticRenderFns } from "./shopXq.vue?vue&type=template&id=7826cce0&scoped=true"
import script from "./shopXq.vue?vue&type=script&lang=js"
export * from "./shopXq.vue?vue&type=script&lang=js"
import style0 from "./shopXq.vue?vue&type=style&index=0&id=7826cce0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7826cce0",
  null
  
)

export default component.exports